import { Inline, Stack, Text, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';

interface GFSTripFarePriceProps {
  selectedTripPricePerAdult: number;
}

const pricePerPersonSection = css`
  border-top: 1px solid ${vars.colors.divider};
  padding-top: 16px;
`;
const GFSTripFarePrice = ({ selectedTripPricePerAdult }: GFSTripFarePriceProps) => {
  const { t } = useTranslation();
  const formattedPrice = priceUtils.formatPrice(selectedTripPricePerAdult);

  return (
    <Inline align="end" className={pricePerPersonSection} data-testid="trip-fare-price-gfs">
      <Stack align="end" spacing={0}>
        <Text as="span" variant="24-emphasized">
          {formattedPrice}
        </Text>
        <Text>{t('Result.PricePerAdult.Text')}</Text>
      </Stack>
    </Inline>
  );
};

export default GFSTripFarePrice;
